import React, { useState } from 'react';

import { connect } from 'react-redux';
import { Spin } from 'antd';
import style from './SelectionOfSuppliers.module.scss';
import * as actions from '../../../redux/actions/advancedSearch';
import * as suppliersActions from '../../../redux/actions/selectionOfSuppliers';
import AdvancedSearch from '../../blocks/AdvancedSearch';
import SelectionOfSuppliersSearchResult from '../../blocks/SuppliersSearchResult';
import SelectionOfSuppliersInfo from '../../blocks/PageInfo/SuppliersInfo';
import api from '../../../helpers/api';
import { IAdvancedSearch, IState } from '../../../types/interfaces';
import SuppliersSearch from '../../blocks/Search/suppliersSearch';
import { Works, works } from '../../blocks/Works';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';
// import formatRegions from '../../../helpers/formatRegions';

interface IProps {
  setAdvancedSearchValue: (payload: string) => void;
  options: IAdvancedSearch;
  setSuppliers: Function;
  setSuppliersSearchId: Function;
  setSuppliersSearchErrors: Function;
}

const SelectionOfSuppliers = ({
  setAdvancedSearchValue,
  options,
  setSuppliers,
  setSuppliersSearchId,
  setSuppliersSearchErrors,
}: IProps) => {
  const [showAdvancedSearch, setShowAdvancedSearch] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const getStatus = async (id: number) => {
    setIsLoading(true);
    const status = await api.getSuppliersSearchStatus(id).then((res) => res);
    if (status !== 'done') setTimeout(() => getStatus(id), 1000);
    if (status === 'done') {
      api.getSuppliersData(id).then((data) => {
        setSuppliers(data);
        setIsLoading(false);
      });
    }
  };

  const onSubmit = async () => {
    if (works) return;

    try {
      const newOptions = { ...options, ...getReferrerFrom() };
      newOptions.okpd2_codes = options.okpd2_codes.map((el) => el.split(' ')[0]);
      const normalizeRegions = options.regions.map((el) => {
        const firstWord = el.split(' ')[0];
        // Данные приходят в ужасном формате, запрос ожидает получить либо код региона
        // либо полностью название региона если в нём отсутствует код
        if (typeof +firstWord === 'number' && !Number.isNaN(+firstWord)) {
          return firstWord;
        }
        const result: any = new Set([...el.split(' ')]);
        return [...result].join(' ');
      });
      const normalizeBidsRegions = options.bids_regions.map((el) => {
        const firstWord = el.split(' ')[0];
        // Данные приходят в ужасном формате, запрос ожидает получить либо код региона
        // либо полностью название региона если в нём отсутствует код
        if (typeof +firstWord === 'number' && !Number.isNaN(+firstWord)) {
          return firstWord;
        }
        const result: any = new Set([...el.split(' ')]);
        return [...result].join(' ');
      });
      const normalizeRegionsCode = options.regions_by_inn.map((el) => {
        const firstWord = el.split(' ')[0];
        // Данные приходят в ужасном формате, запрос ожидает получить либо код региона
        // либо полностью название региона если в нём отсутствует код
        if (typeof +firstWord === 'number' && !Number.isNaN(+firstWord)) {
          return firstWord;
        }
        const result: any = new Set([...el.split(' ')]);
        return [...result].join(' ');
      });

      newOptions.regions_by_inn = [...normalizeRegionsCode];
      newOptions.regions = [...normalizeRegions];
      newOptions.bids_regions = [...normalizeBidsRegions];
      api.startSuppliersSearch(newOptions).then((id) => {
        getStatus(id);
        setSuppliersSearchId(id);
      });
      await api.sendReport(api.API_SUPPLIERS_SEARCH_REPORT_TYPE, { ...newOptions });
    } catch (error: any) {
      setSuppliersSearchErrors(error.message);
    }
  };

  return (
    <>
      <div className={showAdvancedSearch ? style.container_open_advanced_search : style.container}>
        <SelectionOfSuppliersInfo />
        <SuppliersSearch
          showAdvancedSearch={showAdvancedSearch}
          setShowAdvancedSearch={setShowAdvancedSearch}
          onSubmit={onSubmit}
          setAdvancedSearchValue={setAdvancedSearchValue}
          value={options.tags}
          okpd2Codes={options.okpd2_codes}
        />
        {showAdvancedSearch && <AdvancedSearch />}
      </div>
      {isLoading ? (
        <div className={style.spin}>
          <Spin />
        </div>
      ) : (
        <SelectionOfSuppliersSearchResult />
      )}
      <Works />
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  options: state.advancedSearch,
});

export default connect(mapStateToProps, { ...actions, ...suppliersActions })(SelectionOfSuppliers);
